import {FC} from 'react';
//mui
import {Box, Drawer, Typography, useMediaQuery} from '@mui/material';
//formik
import {Field, useFormikContext} from 'formik';
import {AttendeeDetailsFormValues} from '../formConfiguration';
//constants
import {
  ADDRESS_INFO,
  BODY1,
  CANCEL,
  FIELD,
  FIELD_LABEL,
  NONE,
  OPTIONAL,
  PERSONAL_INFO,
  PLACEHOLDER,
  SAVE_CHANGES,
  SUBTITLE1,
  mealsSelectOptions,
} from '@/utils/constants';
import Input from '@/shared/components/Inputs/Input';
import MultipleSelect from '@/shared/components/MultipleSelect';
import AttendeeTablePurchaser from './AttendeeTablePurchaser';
import BlockAttendeeAccount from './BlockAttendeeAccount';
import {formContentStyle} from './FormContent.styles';
import TableFooterActions from '@/shared/components/Table/TableFooterActions';
import {AttendeeDetailsPageStyle} from '@/pages/Organization/AttendeeDetails/AttendeeDetails.styles';
import Button from '@/shared/components/Button';
import {getAttendeeSelector} from '@/store/organization-attendees';
// import CaptureCreditCardInformation from './CaptureCreditCardInformation';
import NotificationSection from './NotificationSection';
import {useAppSelector} from '@/store/hooks';
import { setRequiredLabel } from '@/utils/helpers';

const FormContent: FC = () => {
  const attendee = useAppSelector(getAttendeeSelector);

  const {
    submitForm,
    values: {meals},
    resetForm,
  } = useFormikContext<AttendeeDetailsFormValues>();

  const isMobile = useMediaQuery('(max-width:767.98px)');

  return (
    <Box sx={formContentStyle.wrapper}>
      <AttendeeTablePurchaser />

      <Box sx={formContentStyle.content}>
        <Box sx={formContentStyle.item}>
          <Typography variant={SUBTITLE1} sx={{...formContentStyle.title, ...formContentStyle.itemField}}>
            {PERSONAL_INFO}
          </Typography>

          <Box sx={{...formContentStyle.itemField, ...formContentStyle.addressTitle}}>
            <Typography variant={SUBTITLE1} sx={formContentStyle.title}>
              {ADDRESS_INFO}
            </Typography>
            <Typography variant={BODY1} sx={formContentStyle.title}>
              ({OPTIONAL})
            </Typography>
          </Box>
        </Box>

        <Box sx={formContentStyle.item}>
          <Field
            id={FIELD.firstName}
            name={FIELD.firstName}
            placeholder={PLACEHOLDER.firstName}
            label={setRequiredLabel(FIELD_LABEL.firstName)}
            component={Input}
            parentClassName={formContentStyle.itemField}
          />
          {!isMobile && (
            <Field
              id={FIELD.address}
              name={FIELD.address}
              placeholder={PLACEHOLDER.address}
              label={FIELD_LABEL.address}
              component={Input}
              parentClassName={formContentStyle.itemField}
            />
          )}
        </Box>
        <Box sx={formContentStyle.item}>
          <Field
            id={FIELD.lastName}
            name={FIELD.lastName}
            placeholder={PLACEHOLDER.lastName}
            label={setRequiredLabel(FIELD_LABEL.lastName)}
            component={Input}
            parentClassName={formContentStyle.itemField}
          />
          {!isMobile && (
            <Field
              id={FIELD.city}
              name={FIELD.city}
              placeholder={PLACEHOLDER.city}
              label={FIELD_LABEL.city}
              component={Input}
              parentClassName={formContentStyle.itemField}
            />
          )}
        </Box>
        <Box sx={formContentStyle.item}>
          <Field
            id={FIELD.email}
            name={FIELD.email}
            placeholder={PLACEHOLDER.email}
            label={FIELD_LABEL.email}
            component={Input}
            parentClassName={formContentStyle.itemField}
          />
          {!isMobile && (
            <Field
              id={FIELD.state}
              name={FIELD.state}
              placeholder={PLACEHOLDER.state}
              label={FIELD_LABEL.state}
              component={Input}
              parentClassName={formContentStyle.itemField}
            />
          )}
        </Box>
        <Box sx={formContentStyle.item}>
          <Field
            id={FIELD.phoneNumber}
            name={FIELD.phoneNumber}
            placeholder={PLACEHOLDER.phoneNumberZero}
            label={FIELD_LABEL.phone}
            component={Input}
            parentClassName={formContentStyle.itemField}
          />
          {!isMobile && (
            <Field
              id={FIELD.zip}
              name={FIELD.zip}
              placeholder={PLACEHOLDER.zip}
              label={FIELD_LABEL.zip}
              component={Input}
              parentClassName={formContentStyle.itemField}
            />
          )}
        </Box>
        <Field
          id={FIELD.meals}
          name={FIELD.meals}
          value={meals}
          defaultValue={NONE}
          label={FIELD_LABEL.meal}
          component={MultipleSelect}
          options={mealsSelectOptions}
        />
      </Box>

      <NotificationSection />

      <BlockAttendeeAccount />
      {/* <CaptureCreditCardInformation /> */}

      <Drawer
        variant="permanent"
        anchor="bottom"
        sx={{
          ...AttendeeDetailsPageStyle.drawer,
          paddingTop: attendee?.status === 'Pending' ? '140px' : '80px',
        }}
      >
        <Box sx={AttendeeDetailsPageStyle.popup}>
          {/* <Button
            title={CAPTURE_CREDIT_CARD_INFORMATION}
            variant="outlined"
            sx={AttendeeDetailsPageStyle.buttonCard}
            disabled={attendee?.isUnknown}
          /> */}
          <Button title={SAVE_CHANGES} onClick={submitForm} />
        </Box>
      </Drawer>

      <TableFooterActions
        titleButtonPrev={CANCEL}
        titleButtonNext={SAVE_CHANGES}
        onClickButtonPrev={resetForm}
        onClickButtonNext={submitForm}
      />
    </Box>
  );
};

export default FormContent;
